import { Backdrop, CircularProgress, Typography } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import React from 'react';

const LoadingOverlay = ({ isLoading, loadingMessage }) => {
  const t = useTranslate();

  return (
    <Backdrop
      open={isLoading}
      style={{
        zIndex: 9999,
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
      }}
    >
      <CircularProgress color="primary" />
      <Typography variant="body2">{loadingMessage || t('ra.page.loading')}</Typography>
    </Backdrop>
  );
};

export default LoadingOverlay;
